const BadgeController = require('./badge-controller');

module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'ctrl',
        controller: BadgeController,
        bindToController: {
            wasPrice: '=',
            size: '@?'
        },
        scope: {},
        template: require('./super-savers-badge-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/super-savers-badge-directive.js
 **/